import React, { useState } from 'react';
import cx from 'classnames';

import { cssVars } from 'utils/helpers/css-vars';
import { getPlayerInitials, resolvePlayerPhotoUrl } from 'utils/helpers/player-profile-utils';

import styles from './player-headshot.module.css';

const MIN_INITIALS_FONT_SIZE = 11;
const INITIALS_FONT_SIZE_RATIO = 0.36;

export type PlayerHeadshotProps = {
    firstName?: string | null;
    lastName?: string | null;
    /** the initials come from it when there is no first and last name */
    name?: string;
    photoUrl?: string | null;
    /** px */
    size?: number;
    /** takes the size of the parent instead of `size` (the initials font still follows `size`) */
    fillContainer?: boolean;
    className?: string;
};

const PlayerHeadshot = ({
    firstName,
    lastName,
    name,
    photoUrl,
    size = 36,
    fillContainer = false,
    className
}: PlayerHeadshotProps) => {
    // A photo that failed to load (a dead link) shows the initials; another url is tried again
    const [failedPhotoUrl, setFailedPhotoUrl] = useState<string | null>(null);
    const loadablePhotoUrl = resolvePlayerPhotoUrl(photoUrl);
    const resolvedPhotoUrl = loadablePhotoUrl !== failedPhotoUrl ? loadablePhotoUrl : null;
    const fontSize = Math.max(MIN_INITIALS_FONT_SIZE, Math.round(size * INITIALS_FONT_SIZE_RATIO));

    return (
        <div
            className={cx(
                styles.avatar,
                resolvedPhotoUrl ? styles.photo : styles.initials,
                fillContainer && styles.fill,
                className
            )}
            style={cssVars({ '--headshot-size': `${size}px`, '--headshot-font-size': `${fontSize}px` })}
            aria-hidden
        >
            {resolvedPhotoUrl ? (
                <img
                    className={styles.image}
                    src={resolvedPhotoUrl}
                    alt=""
                    onError={() => setFailedPhotoUrl(resolvedPhotoUrl)}
                />
            ) : (
                getPlayerInitials(firstName, lastName, name)
            )}
        </div>
    );
};

export default PlayerHeadshot;
